import $ from 'jquery';
import 'webpack-jquery-ui/css';
import 'webpack-jquery-ui/sortable';
import 'webpack-jquery-ui/draggable';
import dt from 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.css';
import 'datatables.net-responsive-bs4';
import 'datatables.net-responsive-bs4/css/responsive.bootstrap4.css';
import 'popper.js';
import 'bootstrap';
import 'bootstrap-toggle/css/bootstrap-toggle.css';
import 'bootstrap-select';
import 'bootstrap-select/dist/js/i18n/defaults-ja_JP';
import 'bootstrap-select/dist/css/bootstrap-select.css';
import 'jquery-timepicker/jquery.timepicker.css';
import 'jquery-qrcode/jquery.qrcode.min';
import 'jquery.splitter/css/jquery.splitter.css';
import 'jquery.splitter/js/jquery.splitter';
import 'jquery.cookie';
import 'slick-carousel';
import { Calendar } from '@fullcalendar/core';
import jaLocale from '@fullcalendar/core/locales/ja';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import bootstrapPlugin from '@fullcalendar/bootstrap';

window.$ = $;
window.jQuery = $;
window.$.DataTable = dt;
window.moment = require('moment');
window.timepicker = require('jquery-timepicker/jquery.timepicker');
window.bootstrapToggle = require('bootstrap-toggle');
window.Calendar = Calendar;
window.jaLocale = jaLocale;
window.dayGridPlugin = dayGridPlugin;
window.timeGridPlugin = timeGridPlugin;
window.listPlugin = listPlugin;
window.interactionPlugin = interactionPlugin;
window.bootstrapPlugin = bootstrapPlugin;

import "./index.scss";
